import React, {
  CSSProperties,
  Dispatch,
  SetStateAction,
  useEffect
} from 'react';

interface IProps {
  className?: string;
  isActive: boolean;
  seconds: number;
  style?: CSSProperties;
  setIsActive: Dispatch<SetStateAction<boolean>>;
  setSeconds: Dispatch<SetStateAction<number>>;
}

const Countdown = ({
  className,
  isActive,
  seconds,
  style,
  setIsActive,
  setSeconds
}: IProps) => {
  useEffect(() => {
    let intervalId: NodeJS.Timeout | undefined;

    if (isActive && seconds > 0) {
      intervalId = setInterval(() => {
        setSeconds((prev) => prev - 1);
      }, 1000);
    }

    if (seconds === 0) {
      setIsActive(false);
      clearInterval(intervalId);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [isActive, seconds]);

  const formatCountdown = (num: number) => {
    const min = Math.floor(num / 60);
    const sec = Math.floor(num % 60);
    const parseMin = min < 10 ? `0${min}` : `${min}`;
    const parseSec = sec < 10 ? `0${sec}` : `${sec}`;
    return `${parseMin}:${parseSec}`;
  };

  return (
    <span className={className} style={style}>
      {formatCountdown(seconds)}
    </span>
  );
};

export default Countdown;
